import "./index.sass";

export const PreviewLoader = ({ loading }) => {
  const candles = [25, 40, 18, 55, 32, 48, 22, 38];

  return (
    <>
        <div className={`previewLoader ${loading ? "" : "hidden"}`}>
      <div className="previewLoader__container">
        <div className="previewLoader__candles">
          {candles.map((height, i) => (
            <div
              key={i}
              className="previewLoader__candle"
              style={{
                "--i": `${i}`,
                "--height": `${height}`,
              }}
            >
              <div className="previewLoader__candle-body" />
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
    
  );
};
